<template>
  <div class="home">
    <Loader />
    <Confirm :message="message" />
    <postForm v-if="postFormValidation" :randuniq="randuniq" />

    <div class="home__slider">
      <!-- PARTIE FIXE -->
      <div v-if="!UnvalidUrl">
        <div
          v-if="
            Maindata.slides &&
            Maindata.slides[0] &&
            Maindata.slides[0].unique === true
          "
          class="home__slider__title"
        >
          <h1>{{ Maindata.slides?.[0]?.titleSlider }}</h1>
          <h2>{{ Maindata.slides?.[0]?.claimSlider }}</h2>
        </div>
      </div>

      <!-- SLIDER -->
      <!-- SLIDER UNDEFINED -->
      <swiper-container
        v-if="UnvalidUrl"
        class="home__slider__swiper swiper-container"
        slides-per-view="1"
        speed="500"
        loop="true"
        navigation="true"
        autoplay="false"
        pauseOnMouseEnter="false"
      >
        <swiper-slide>
          <Slide
            carname=""
            claim=""
            offre=""
            imgUrl="assets/slide_default.jpg"
            uniqueoffre=""
          />
        </swiper-slide>
      </swiper-container>

      <!-- SLIDER DESKTOP -->
      <swiper-container
        v-if="!UnvalidUrl && Maindata.slides && Maindata.slides[0]"
        class="home__slider__swiper swiper-container"
        :slides-per-view="1"
        :pagination="true"
        :speed="700"
        :loop="true"
        :navigation="true"
        :autoplay="false"
        :initial-slide="initialSlide"
        @slidechange="emitSlide"
      >
        <swiper-slide
          v-for="(item, index) in Maindata.slides"
          :key="index"
          :data-fixed-index="index"
        >
          <Slide
            v-if="
              item.titleSlider !== undefined && item.claimSlider !== undefined
            "
            :carname="item.titleSlider"
            :claim="item.claimSlider"
            :offre="item.offersSlider"
            :imgUrl="item.image"
            :ml="item.mentions_legaleSlider"
            :uniqueoffre="Maindata.slides?.[0]?.unique"
            :pl="item.polluscoreSlider"
          />
          <Slide
            v-else
            carname=""
            claim=""
            offre=""
            :imgUrl="item.image"
            :uniqueoffre="Maindata.slides?.[0]?.unique"
          />
        </swiper-slide>
      </swiper-container>
      <div
        v-if="Maindata.slides?.[0]?.unique === true && offreFixedUrl"
        class="home__slider__offre"
      >
        <img :src="offreFixedUrl" alt="Offre" width="auto" height="auto" />
      </div>

      <div
        class="home__slider__conditions"
        @click="DisplayML"
        v-if="!UnvalidUrl"
      >
        <p>Voir conditions</p>
      </div>
    </div>

    <div class="home__formsection">
      <!-- FORMULAIRE -->
      <FormMap
        v-if="
          Maindata.formulaire &&
          Maindata.formulaire[0] &&
          Maindata.formulaire[0].form === 'FormLocal'
        "
        :data="{ Maindata }"
        :scenario="scenario"
        :utmSource="utmSource"
        :utmParteners="utmParteners"
        :sapParam="sapParam"
        :modele="modele"
        :postformValid="postFormValidation"
        :error="error"
        :optin="optin"
        :randuniq="randuniq"
        :formParams="formParams"
      />
      <FormBasique
        v-else-if="
          Maindata.formulaire &&
          Maindata.formulaire[0] &&
          Maindata.formulaire[0].form === 'FormB2C'
        "
        :data="{ Maindata }"
        :error="error"
        :scenario="scenario"
        :utmSource="utmSource"
        :utmParteners="utmParteners"
        :modele="modele"
        :postformValid="postFormValidation"
        :optin="optin"
        :randuniq="randuniq"
        :formParams="formParams"
      />

      <FormB2B
        v-else-if="
          Maindata.formulaire &&
          Maindata.formulaire[0] &&
          Maindata.formulaire[0].form === 'FormB2B'
        "
        :data="{ Maindata }"
        :modele="modele"
        :postformValid="postFormValidation"
        :utmSource="utmSource"
        :utmParteners="utmParteners"
        :error="error"
        :optin="optin"
        :randuniq="randuniq"
        :formParams="formParams"
      />

      <FormB2BLocal
        v-else-if="
          Maindata.formulaire &&
          Maindata.formulaire[0] &&
          Maindata.formulaire[0].form === 'FormB2B_Local'
        "
        :data="{ Maindata }"
        :sapParam="sapParam"
        :modele="modele"
        :postformValid="postFormValidation"
        :utmSource="utmSource"
        :utmParteners="utmParteners"
        :error="error"
        :optin="optin"
        :randuniq="randuniq"
        :formParams="formParams"
      />

      <FormBasiqueError
        v-else
        :error="true"
        :scenario="scenario"
        :modele="modele"
        :postformValid="postFormValidation"
        :utmSource="utmSource"
        :utmParteners="utmParteners"
        :optin="optin"
        :randuniq="randuniq"
        :formParams="formParams"
      />

      <!-- ML & GARANTIES -->
      <Mention
        v-if="!UnvalidUrl"
        :slug="stores.slug_mention"
        :slideSlug="stores.mentions[this.indexData]"
        :uniqueoffre="Maindata.slides?.[0]?.unique"
        :polluscore="stores.pl[this.indexData]"
        ref="mentionComponent"
      />
      <Mention
        v-if="UnvalidUrl"
        :slug="stores.slug_mention"
        :polluscore="stores.pl[this.indexData]"
        ref="mentionComponent"
      />
      <RGPD />
    </div>
  </div>
</template>

<script>
//JS
import { register } from "swiper/element/bundle";
register();

import stores from "@/assets/js/store/store";
import { ToggleML, ToggleRGPD } from "@/assets/js/ToggleML";
import { useApiStore } from "@/pinia/api";

//COMPONENTS
import Mention from "@/components/Mentions.vue";
import RGPD from "@/components/Rgpd.vue";
import Loader from "@/components/Loader.vue";
import Slide from "@/components/Slide.vue";
import Confirm from "@/components/Confirm.vue";
import postForm from "@/components/features/postForm.vue";

//COMPONENT FORM
import FormBasique from "@/components/formulaire/FormBasique.vue";
import FormMap from "@/components/formulaire/FormMap.vue";
import FormB2B from "@/components/formulaire/FormB2B.vue";
import FormBasiqueError from "@/components/formulaire/FormBasiqueError.vue";
import FormB2BLocal from "@/components/formulaire/FormB2BLocal.vue";

export default {
  name: "HomeView",
  components: {
    Slide,
    Loader,
    Mention,
    FormBasique,
    FormMap,
    FormB2B,
    Confirm,
    RGPD,
    FormBasiqueError,
    FormB2BLocal,
    postForm,
  },

  data() {
    return {
      api: useApiStore(),
      stores,
      offreFixedUrl: "",
      mloffer: "",
      UnvalidUrl: false,
      DesktopDevice: false,
      Maindata: {
        slides: [],
        formulaire: [],
      },
      initialSlide: 0,
      ml: [],
      indexData: 0,
      slideSlug: [],
      message: "",
      scenario: "",
      utmSource: "",
      utmParteners: "",
      modele: "",
      sapParam: "",
      postFormValidation: "",
      optin: true,
      randuniq: "",
      sovReqToken: null,
      formParams: {
        lastname: null,
        firstname: null,
        email: null,
        gender: null,
        phone: null,
        city: null,
        cp: null,
      },
    };
  },

  mounted() {
    console.log(this.api.baseUrl);
    this.GetAllBlocOffres();
    this.urlParams();
    this.initEnovateTracking();

    this.randuniq = stores.randuniq;

    if (window.innerWidth > 768) {
      this.DesktopDevice = true;
    }

    //SLIDER
    this.InitSlider();
    this.SendDodClic();
  },

  methods: {
    urlParams() {
      const urlParams = new URLSearchParams(window.location.search);

      this.scenario = urlParams.get("i");
      this.sovReqToken = urlParams.get("sovReqToken");
      this.utmSource = urlParams.get("utm_source");
      this.utmParteners = urlParams.get("utm_parteners");
      this.sapParam = urlParams.get("utm_dealer");
      this.iid = urlParams.get("iid"); // Ajout du paramètre iid

      this.formParams = {
        lastname: urlParams.get("nom"),
        firstname: urlParams.get("prenom"),
        email: urlParams.get("email"),
        gender: urlParams.get("civilite"),
        phone: urlParams.get("telephone"),
        city: urlParams.get("ville"),
        cp: urlParams.get("cp"),
      };
    },

    //// SCRIPT TRACKING
    initEnovateTracking() {
      if (this.scenario !== "o6qbrgty9s") {
        return;
      }

      console.log("ENOVATE: script initialized");

      const ENOVATE_LOC_PARAM = "loc";
      const ENOVATE_PERF_PARAM = "enovateperf";
      const ENOVATE_CONV_URL = "https://enovate.156th.com/conv?chid";
      const ENOVATE_LEVEL = "1";

      const getValueFromURL = (url, keyword) => {
        if (!url || !url.includes(keyword)) {
          return null;
        }

        try {
          const targetUrl = url.startsWith("http")
            ? new URL(url)
            : new URL(url, window.location.origin);
          return new URLSearchParams(targetUrl.search).get(keyword);
        } catch (error) {
          try {
            return new URLSearchParams(url).get(keyword);
          } catch (parseError) {
            console.warn("ENOVATE: unable to parse url", url, parseError);
            return null;
          }
        }
      };

      const currentUrl = window.location.href;
      const loc = getValueFromURL(currentUrl, ENOVATE_LOC_PARAM);

      console.log("ENOVATE: found location: ", loc);

      const valueFromLoc = loc
        ? getValueFromURL(loc, ENOVATE_PERF_PARAM)
        : null;
      const value =
        valueFromLoc || getValueFromURL(currentUrl, ENOVATE_PERF_PARAM);

      console.log("ENOVATE: found value: ", value);

      if (value) {
        const trackingPixel = new Image();
        trackingPixel.src = `${ENOVATE_CONV_URL}=${encodeURIComponent(
          value
        )}&level=${ENOVATE_LEVEL}`;
      }
    },

    //CHARGE TOUT LES BLOC OFFFRE DANS LE STORE AU LANCEMENT DE LA PAGE
    async GetAllBlocOffres() {
      let year = new Date().getFullYear();
      let month = ("0" + (new Date().getMonth() + 1)).slice(-2);

      var myHeaders = new Headers();
      myHeaders.append("xc-api-token", this.api.xcToken);
      myHeaders.append("x-table-id", this.api.Offers);
      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      let param = encodeURIComponent("(date,eq," + year + month + ")");

      let response = await fetch(
        this.api.baseUrl + "?where=" + param,
        requestOptions
      );
      response = await response.json();
      stores.bloclist = await response.list[0].files;

      await this.FetchData();
      this.emitSlide();
    },

    DisplayML() {
      stores.slug_mention = "";
      const mentionComponent = this.$refs.mentionComponent;
      if (mentionComponent) {
        // Appelez la fonction dans le composant enfant
        mentionComponent.ManageML();
      }
      ToggleML();
    },

    emitSlide() {
      setTimeout(() => {
        stores.slug_mention = "";
        let index = document.querySelector(".swiper-slide-active");
        if (index !== null) {
          let indexDataString = index.getAttribute("data-fixed-index");
          this.indexData = parseInt(indexDataString);
        } else {
          this.emitSlide();
        }
      }, 500);
    },

    async FetchData() {
      const SceParam = new URLSearchParams(window.location.search).get("i");
      const apiUrl = `${this.api.baseUrl}?where=(uuid,eq,${SceParam})`;
      if (!SceParam) {
        this.error = true;
      } else {
        this.error = false;
      }

      const requestOptions = {
        method: "GET",
        headers: {
          "xc-api-token": this.api.xcToken,
          "x-table-id": this.api.Scenario,
        },
        redirect: "follow",
      };

      try {
        const response = await fetch(apiUrl, requestOptions);

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        // console.log(result.list[0])
        if (result.list.length === 0) {
          this.UnvalidUrl = true;
          // console.log(this.UnvalidUrl);
          return;
        }

        this.processApiResponse(result.list[0]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    processApiResponse(result) {
      console.log(result);
      this.Maindata = result;

      this.postFormValidation = this.Maindata.formulaire[0].postForm;
      this.optin = this.Maindata.formulaire[0].optin;

      // replace the content [sowReqToken] by the sowReqToken value
      if (this.Maindata.formulaire[0].trackingForm) {
        this.Maindata.formulaire[0].trackingForm =
          this.Maindata.formulaire[0].trackingForm.replace(
            "[sovReqToken]",
            this.sovReqToken
          );
      }

      // Si 'formulaire' est un tableau non vide avant d'accéder à son premier élément
      if (this.Maindata.formulaire && this.Maindata.formulaire.length > 0) {
        this.message = this.Maindata.formulaire[0].confirmation_messageForm;
      }
      if (this.Maindata.slides && this.Maindata.slides.length > 0) {
        const blocList = stores.bloclist;

        // Si 'blocList' est un tableau non vide avant d'accéder à son premier élément
        if (blocList && blocList.length > 0) {
          const targetTitle = this.Maindata.slides[0].offersSlider;

          const matchedItem = blocList.find(
            (item) => item.title === targetTitle
          );

          if (matchedItem) {
            this.offreFixedUrl = `${this.api.baseUrl}${matchedItem.path}`;
          }
        }
      }

      this.SelectSlide();
      this.displayCookie();
    },

    displayCookie() {
      let cookie = document.getElementById("cc-main");

      if (
        this.Maindata.formulaire[0].form === "FormB2B_Local" ||
        this.Maindata.formulaire[0].form === "FormLocal"
      ) {
        cookie.style.display = "block";
        cookie.style.opacity = "1";
      }
    },

    InitSlider() {
      register();

      const swiperEl = document.querySelector("swiper-container");
    },

    //DETECT SLIDE
    SelectSlide() {
      const urlParams = new URLSearchParams(window.location.search);
      const slideParam = urlParams.get("slide");

      if (slideParam) {
        this.initialSlide = slideParam;
      }
    },

    SendDodClic() {
      let t = this;
      const urlParams = new URLSearchParams(window.location.search);

      let _did = urlParams.get("_did") || "";
      let utm_puid = urlParams.get("utm_puid") || "";
      let puid = urlParams.get("puid") || "";
      let utm_segmentekino = urlParams.get("utm_segmentekino") || "";
      let utm_campaignid = urlParams.get("utm_campaignid") || "";
      let utm_medium = urlParams.get("utm_medium") || "";
      let utm_source = urlParams.get("utm_source") || "";
      let utm_content = urlParams.get("utm_content") || "";
      let utm_campaign = urlParams.get("utm_campaign") || "";
      let campaign_id = urlParams.get("campaign_id") || "";
      let customer_id = urlParams.get("customer_id") || "";
      let actId = urlParams.get("actId") || "";

      // Si le visiteur quitte rapidement (2s) - ignorer
      setTimeout(function () {
        let type =
          typeof t.Maindata.Type == "undefined"
            ? "undefined"
            : t.Maindata.Type.title;

        fetch(
          `https://05m.fr/clictrack?campagne=hyundai_lp
            &origine=${t.randuniq}
            &levier=${t.scenario}
            &_did=${_did}
            &campaign=${t.Maindata.campaign}
            &sapParam=${t.sapParam}
            &type=${type}
            &utm_puid=${utm_puid}
            &puid=${puid}
            &utm_segmentekino=${utm_segmentekino}
            &utm_campaignid=${utm_campaignid}
            &utm_medium=${utm_medium}
            &utm_source=${utm_source}
            &utm_content=${utm_content}
            &utm_campaign=${utm_campaign}
            &campaign_id=${campaign_id}
            &customer_id=${customer_id}
            &actId=${actId}
            &parteners=${t.utmParteners}
            &source=${t.utmSource}`,
          {
            method: "GET",
            redirect: "follow",
          }
        );
      }, 2000);
    },
  },
};

console.info(
  "\r\n░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░\r\n░░░░░░░░░░░░░░░░░░░░░░▒▒▓▓▓▓███████████████▓▓▓▒▒▒░░░░░░░░░░░░░░░░░░░░░\r\n░░░░░░░░░░░░░░░▒▒▓██████████████▓▒▒▒▒▒▒▒▒▒▓▓▓▓██████▓▓▒░░░░░░░░░░░░░░░\r\n░░░░░░░░░░░▒▓████▓▓▒░░░░██████▓░░░░░░░░░░░░░░░░░░░▒▒█████▓▒░░░░░░░░░░░\r\n░░░░░░░░▒▓███▓▒░░░░░░░▒██████▓░░░░░░░░░░░░░░░░░░░░▒▓█████████▓░░░░░░░░\r\n░░░░░░▓███▒░░░░░░░░░░████████░░░░░░░░░░░░░░░░░░▒▓████████▒░▒▓██▓▒░░░░░\r\n░░░░▒███░░░░░░░░░░░▒████████▒░░░░░░░░░░░░░▒▒▓███████████▒░░░░░▓██▓░░░░\r\n░░░▒██▒░░░░░░░░░░░▒█████████▓░░░░░░░░▒▒▓███████████████▓░░░░░░░░███░░░\r\n░░░██▓░░░░░░░░░░░▓█████████████▓▓█████████████████████▓░░░░░░░░░░██▒░░\r\n░░░██▒░░░░░░░░░░▓████████████████████████████████████▓░░░░░░░░░░░██▓░░\r\n░░░███░░░░░░░░░▓██████████████████▓▓▒▒▒▒▒███████████▓░░░░░░░░░░░▒██▒░░\r\n░░░░███░░░░░░░▓██████████████▓▒░░░░░░░░░░░█████████▒░░░░░░░░░░░▓██▓░░░\r\n░░░░░▓██▓░░░░▒██████████▓▒░░░░░░░░░░░░░░░░████████░░░░░░░░░░░▒███▒░░░░\r\n░░░░░░░▓██▓▒▒████████▓░░░░░░░░░░░░░░░░░░░▓██████▓░░░░░░░░░▒▓███▒░░░░░░\r\n░░░░░░░░░▒▓███████▓░░░░░░░░░░░░░░░░░░░░░▓██████▒░░░░░░▒▓████▓░░░░░░░░░\r\n░░░░░░░░░░░░▒▓▓████▓▓▒▒░░░░░░░░░░░░░░░░▓██████▒▒▒▓▓█████▓▒░░░░░░░░░░░░\r\n░░░░░░░░░░░░░░░░░▒▒▓▓██████████▓▓▓▓▓▓█████████████▓▓▒░░░░░░░░░░░░░░░░░\r\n░░░░░░░░░░░░░░░░░░░░░░░░░▒▒▒▒▓▓▓▓▓▓▓▓▓▓▓▓▒▒▒▒░░░░░░░░░░░░░░░░░░░░░░░░░\r\n"
);
</script>

<style lang="scss">
@import "@/assets/style/variables.scss";

#cc-main {
  opacity: 0;
  display: none;
  transition: all 0.2s ease-in-out;
}
.home {
  height: 100vh;
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: $maxMobile) {
    flex-direction: column;
    justify-content: left;
    min-height: 100vh;
    height: auto;
  }

  &__slider {
    @media screen and (min-width: $maxMobile) and (max-width: $maxTablette) {
      width: 50%;
    }
    @media screen and (max-width: $maxMobile) {
      width: 100%;
      // max-height: 65vh;
    }

    width: 65%;
    position: relative;

    &__title {
      position: absolute;
      top: 0;
      left: 0;
      color: var(--white);
      padding: 25px;
      z-index: 100;

      h1 {
        font-size: 3.5vw;
        text-shadow: 1px 1px #000;
        font-family: "HyundaiMedium";
        font-weight: 500;
      }

      h2 {
        font-family: "HyundaiLight";
        font-size: 1.5vw;
        text-shadow: 1px 1px #000;
      }

      @media screen and (max-width: $maxMobile) {
        h1 {
          font-size: 7vw;
        }

        h2 {
          font-size: 4vw;
        }
      }
    }

    &__offre {
      position: absolute;
      background-color: var(--MainBlue);
      bottom: 13vh;
      left: 0px;
      z-index: 2;
      color: #fff;
      padding: 15px;
      overflow: hidden;
      white-space: nowrap;

      img {
        width: 260px;
        height: auto;
        min-width: 160px;
      }

      @media screen and (max-width: $maxMobile) {
        width: 100%;
        height: 30%;
        position: initial;

        img {
          max-height: 126px;
          width: auto;
        }
      }
    }

    &__swiper {
      height: 100%;
      width: 100%;

      .swiper-slide {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    &__conditions {
      position: absolute;
      bottom: 0;
      left: 0;
      color: var(--white);
      z-index: 100;
      background: rgba(0, 0, 0, 0.7);
      padding: 8px 8px 8px var(--baseUnit);
      font-size: 14px;
      cursor: pointer;
      text-decoration: underline;

      @media screen and (max-width: $maxMobile) {
        left: auto;
        right: 0;
        font-size: 10px;
      }
    }
  }

  &__formsection {
    position: relative;
    width: 35%;
    padding: var(--baseUnit);
    background: #fff;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;

    @include dark {
      background-color: var(--bgDarkMode);
    }

    @media screen and (max-width: $maxMobile) {
      height: fit-content;
      overflow-y: hidden;
    }

    &__logo {
      width: 30%;

      margin-bottom: 15px;
      display: block;
    }

    &__garantie {
      bottom: 0;
      right: 0;
      min-width: 253px;
      width: 50%;

      @media screen and (max-width: $maxMobile) {
        position: relative;
        padding: 0;
      }
    }

    @media screen and (min-width: $maxMobile) and (max-width: $maxTablette) {
      width: 50%;
    }

    @media screen and (max-width: $maxMobile) {
      width: 100%;
      position: inherit;

      &__logo {
        width: 50%;
        max-width: 250px;
        min-width: 150px;
      }
    }
  }
}
</style>
